import { useEffect, useState } from 'react';
import { ApiError, api } from '../api';

export type AsyncState<T> =
  | { kind: 'loading' }
  | { kind: 'ready'; data: T }
  | { kind: 'error'; status: number | null; message: string };

// Tiny `useApi` — fetches once on mount + on `deps` change. Avoids pulling
// in a query library for what's a small handful of read endpoints.

export function useApi<T>(path: string, deps: unknown[] = []): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    setState({ kind: 'loading' });
    api<T>(path)
      .then((data) => {
        if (!cancelled) setState({ kind: 'ready', data });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        if (err instanceof ApiError) {
          setState({ kind: 'error', status: err.status, message: typeof err.body === 'object' && err.body !== null ? JSON.stringify(err.body) : String(err.body) });
        } else {
          setState({ kind: 'error', status: null, message: String(err) });
        }
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);

  return state;
}
